module.exports = __webpack_public_path__ + "img/banner4.d46aca25.png";